/**产品路由 */
export default {
    name: 'product',
    path: 'product',
    meta: {
        title: '产品管理'
    },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'product-information',
            path: 'information',
            meta: { title: '产品信息' },
            component: () => import('@/pages/product/information.vue')
        },
        {
            name: 'product-classification',
            path: 'classification',
            meta: { title: '产品分类' },
            component: () => import('@/pages/product/classification.vue')
        },
        {
            name: 'product-batch',
            path: 'batch',
            meta: { title: '批次管理' },
            component: () => import('@/pages/product/batch.vue')
        },
        {
            name: 'product-attribute',
            path: 'attribute',
            meta: { title: '属性管理' },
            component: () => import('@/pages/product/attribute.vue')
        }
    ]
}

